import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-ebay-user-create',
  templateUrl: './ebay-user-create.component.html',
  styleUrls: ['./ebay-user-create.component.css']
})
export class EbayUserCreateComponent implements OnInit {
  sessionId: string = '';

  productImage: string = "/assets/images/default-product.png";
  concatStatus: string = '';
  tabActive: string = '';
  dropdownList = [];
  importsdropdownList = [];
  importsFulFillmentStatusList = [];
  selectedItems: any = '';
  dropdownSettings: IDropdownSettings = {};
  tabClicked = "ORDERS";
  storeManageId: any;
  storeId: any;
  syncEnabled: boolean = false;
  noOfDays: number;
  startDate: string;
  endDate: string;
  startDateError: string;
  endDateError: string;
  noOfDaysError: string;
  hostName: string;
  hostNames: string;
  passWord: string;
  passWords: string;
  apiKey: string;
  flipkartUserName: string;
  flipkartApiKey: string;
  flipkartPassword: string;
  shopcluesUserName: string;
  shopcluesClientId: string;
  sync: string = 'N';
  shopcluesClientSecret: string;
  selectPeriodicType = 'Date Range';
  shopcluesPassword: string;
  userName: string;
  channelNameWoocommerce: string;
  channelNameShopify: string;
  channelNameEbay: string;
  channelNameShopclues: string;
  //channelNameShopify : string;
  channelNameFlipkart: string;
  disableStatuses = true;
  scheduleOrders: any;
  importProducts: string;
  manualImportsProducts: string;
  scheduleProducts: string;
  version: string;
  statusText: string;
  uploadImage: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  statusText15: string;
  statusText16: string;
  statusText17: string;
  statusText18: string;
  statusText19: string;
  statusText20: string;
  statusText21: string;
  statusText22: string;
  statusText23: string;
  statusText24: string;
  statusText25: string;
  statusText26: string;
  statusText27: string;
  statusText28: string;
  statusText29: string;
  statusText30: string;
  statusText31: string;
  statusText32: string;
  statusText33: string;
  statusText34: string;
  statusText35: string;
  selectedId: string;
  errorMessage: string;
  orders: any = [];
  EbayUserName: string;
  ebayPassword: string;
  ebayDevId: string;
  ebayCertId: string;
  appId: string;
  magentoProducts: any;
  magentoOrders: any;
  shopifyProducts: any;
  wooProducts: any;
  shopifyOrders: any;
  wooOrders: any;
  ebayProducts: any;
  ebayOrders: any;
  flipkartOrders: any;
  shopcluesProducts: any;
  shopcluesOrders: any;
  orderStatuses: any = [];
  providerStatuses: any = [];
  syncId: any;
  syncProductId: any;
  imageUrl: string;
  configurationList: any;
  selectedOrderStatus: any = [];
  storeManage: any = {};
  manualImports: boolean = false;
  updateOrders: boolean = false;
  importOrders: boolean = false;
  store: any = {
    syncType: "",
    syncTypeProducts: ""
  };
  enableSchedule: boolean = false;
  enableScheduleProducts: boolean = false;
  selectPeriodicTypeProducts = 'Date Range';
  noOfDaysProducts: number;
  startDateProducts: string;
  endDateProducts: string;
  startDateErrorProducts: string;
  endDateErrorProducts: string;
  noOfDaysErrorProducts: string;
  sourceOrderNoError: string = '';
  sourceOrderNumber: string = '';
  scheduleStores: any = [];
  scheduleStore: any = {
    syncType: "",
    startDate: "",
    endDate: "",
    duration: "",
  };
  fulfillmentStatus: any;
  wooKey: string
  wooHostName: string
  wooSecretKey: string
  //step: number;
  deleteApiPop: string = 'N';
  editApiPop: string = 'N';
  index: any;
  sysnOrders: any = [];
  sysnFulfillOrders: any = [];
  selectedSyncStatus: any = [];
  selectedFulfillStatus: any = [];
  hostNamePrefix: any;
  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {
    this.g.page = "Create Store Management";
    this.hostNamePrefix = "https://";
    this.orderStatuses = [
      { label: 'New', config: 'SUBMITTED' },
      { label: 'Ready to ship', config: 'READY_TO_SHIP' },
      { label: 'Exception', config: 'EXCEPTION' },
      { label: 'Cancelled', config: 'CANCELLED' },
      { label: 'Delivered', config: 'DELIVERED' },
      { label: 'On Hold', config: 'ON_HOLD' }
    ];
    this.importsdropdownList = [
      { label: 'Open', config: 'Open' },
      { label: 'Closed', config: 'Closed' },
      { label: 'Cancelled', config: 'Cancelled' }
    ];
    this.importsFulFillmentStatusList = [
      { label: 'Shipped', config: 'Shipped' },
      { label: 'Partial', config: 'Partial' },
      { label: 'Unshipped', config: 'Unshipped' }
    ];
    /*this.api.getValues("1", "ORDER_STATUS","SHIFT" ,"SHIFT").subscribe((data:any)=> {this.orderStatuses = data.tripleSetConfigDTOS;},err=> {
         this.alertService.error('Error',err);
          });*/
    this.providerStatuses = [{
      "id": 61,
      "config": "Canceled",
      "orderBy": 1,
      "organizationId": 1
    }, {
      "id": 63,
      "config": "Complete",
      "orderBy": 3,
      "organizationId": 1
    }, {
      "id": 65,
      "config": "On Hold",
      "orderBy": 5,
      "organizationId": 1
    }, {
      "id": 69,
      "config": "Pending",
      "orderBy": 9,
      "organizationId": 1
    }, {
      "id": 72,
      "config": "Processing",
      "orderBy": 12,
      "organizationId": 1
    }];
    /*this.api.getValues("1", "ORDER_STATUS","SHOPIFY" ,"SHOPIFY").subscribe((data:any)=> {this.providerStatuses = data.tripleSetConfigDTOS;},err=> {
         this.alertService.error('Error',err);
          });*/

    this.selectedId = this.route.snapshot.params['id']
  }

  ngOnInit() {
    var today = new Date().toISOString().split('T')[0];
    document.getElementById("startDateProducts").setAttribute('min', today);
    document.getElementById("endDateProducts").setAttribute('min', today);
    document.getElementById("spstartDateProducts").setAttribute('min', today);
    document.getElementById("spendDateProducts").setAttribute('min', today);
    document.getElementById("spendDate").setAttribute('min', today);
    document.getElementById("spstartDate").setAttribute('min', today);
    document.getElementById("startDate").setAttribute('min', today);
    document.getElementById("endDate").setAttribute('min', today);

    this.dropdownList = [
      'New',
      'Pending',
      'Processing',
      'Complete',
      'Closed',
      'Cancelled',
      'On Hold',
      'Payment Review'
    ];

    this.dropdownSettings = {
      singleSelection: false,

      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
  }
  tabChange(tab) {
    this.tabClicked = tab
  }
  getByStoreId(storeId) {
    this.api.getByStoreId(this.user.accountOwnerId, this.user.organizationId, this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.scheduleStores = data.getManageStoreInfoResponses;
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  dateChange(startDate) {
    if (this.store.endDateProducts) {
      this.store.endDateProducts = '';
    }
    document.getElementById("endDateProducts").setAttribute('min', startDate);
  }
  dateChangeSd(startDate) {
    if (this.store.endDate) {
      this.store.endDate = '';
    }
    document.getElementById("endDate").setAttribute('min', startDate);
  }
  dateChangeSp(startDate) {
    if (this.store.eendDate) {
      this.store.eendDate = '';
    }
    document.getElementById("spendDate").setAttribute('min', startDate);
  }
  dateChangeSps(startDate) {
    if (this.store.eendDateProducts) {
      this.store.eendDateProducts = '';
    }
    document.getElementById("spendDateProducts").setAttribute('min', startDate);
  }
  dateChangeFdp(startDate) {
    if (this.endDateProducts) {
      this.endDateProducts = '';
    }
    document.getElementById("toDateProducts").setAttribute('min', startDate);
    document.getElementById("toDateProducts").setAttribute('max', moment(startDate).add(30, 'days').format("YYYY-MM-DD"));
  }
  dateChangeFd(startDate) {
    console.log(startDate);
    if (this.endDate) {
      this.endDate = '';
    }
    document.getElementById("toDate").setAttribute('min', startDate);
    document.getElementById("toDate").setAttribute('max', moment(startDate).add(30, 'days').format("YYYY-MM-DD"));

  }

  typeApiKey() {
    this.statusText11 = "";
    if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
      this.statusText11 = 'Please enter API key';
    }
  }
  typePassword() {
    this.statusText1 = "";
    if (this.passWord == '' || this.passWord === null || this.passWord === undefined || this.passWord === 'undefined') {
      this.statusText1 = 'Please enter password';
    }
  }
  typeHostName() {
    this.statusText2 = "";
    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter hostname';
    } else if (this.hostName.search("https://") > -1) {
      this.statusText2 = 'Please enter with out https://';
    }
  }


  typeHost() {
    this.statusText3 = "";
    if (this.hostNames == '' || this.hostNames === null || this.hostNames === undefined || this.hostNames === 'undefined') {
      this.statusText3 = 'Please enter hostName';
    }
  }
  /*    typeApiKey(){
        this.statusText4 ="";
            if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
              this.statusText4 = 'Please enter apiKey';
              }
            }*/
  typeSecretKey() {
    this.statusText5 = "";
    if (this.passWords == '' || this.passWords === null || this.passWords === undefined || this.passWords === 'undefined') {
      this.statusText5 = 'Please enter password';
    }
  }
  typeVersion() {
    this.statusText6 = "";
    if (this.version == '' || this.version === null || this.version === undefined || this.version === 'undefined') {
      this.statusText6 = 'Please enter version';
    }
  }

  typeFlipKartUser() {
    this.statusText7 = "";
    if (this.flipkartUserName == '' || this.flipkartUserName === null || this.flipkartUserName === undefined || this.flipkartUserName === 'undefined') {
      this.statusText7 = 'Please enter User name';
    }
  }
  typeAp() {
    this.statusText8 = "";
    if (this.flipkartApiKey == '' || this.flipkartApiKey === null || this.flipkartApiKey === undefined || this.flipkartApiKey === 'undefined') {
      this.statusText8 = 'Please enter Api Key';
    }
  }
  typePwd() {
    this.statusText9 = "";
    if (this.flipkartPassword == '' || this.flipkartPassword === null || this.flipkartPassword === undefined || this.flipkartPassword === 'undefined') {
      this.statusText9 = 'Please enter password';
    }
  }


  typeUser() {
    this.statusText10 = "";
    if (this.shopcluesUserName == '' || this.shopcluesUserName === null || this.shopcluesUserName === undefined || this.shopcluesUserName === 'undefined') {
      this.statusText10 = 'Please enter User name';
    }
  }

  typechannelNameShopify() {
    this.statusText22 = "";
    if (this.channelNameShopify == '' || this.channelNameShopify === null || this.channelNameShopify === undefined || this.channelNameShopify === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
  }
  typeClient() {
    this.statusText11 = "";
    if (this.shopcluesClientId == '' || this.shopcluesClientId === null || this.shopcluesClientId === undefined || this.shopcluesClientId === 'undefined') {
      this.statusText11 = 'Please enter Client id';
    }
  }
  typeClientSecret() {
    this.statusText12 = "";
    if (this.shopcluesClientSecret == '' || this.shopcluesClientSecret === null || this.shopcluesClientSecret === undefined || this.shopcluesClientSecret === 'undefined') {
      this.statusText12 = 'Please enter Client Secret ';
    }
  }
  typeShopCluesPwd() {
    this.statusText13 = "";
    if (this.shopcluesPassword == '' || this.shopcluesPassword === null || this.shopcluesPassword === undefined || this.shopcluesPassword === 'undefined') {
      this.statusText13 = 'Please enter Password';
    }
  }


  typeEbayUser() {
    this.statusText14 = "";
    if (this.EbayUserName == '' || this.EbayUserName === null || this.EbayUserName === undefined || this.EbayUserName === 'undefined') {
      this.statusText14 = 'Please enter User name';
    }
  }
  typeEbayPwd() {
    this.statusText15 = "";
    if (this.ebayPassword == '' || this.ebayPassword === null || this.ebayPassword === undefined || this.ebayPassword === 'undefined') {
      this.statusText15 = 'Please enter Password';
    }
  }
  typeDevId() {
    this.statusText16 = "";
    if (this.ebayDevId == '' || this.ebayDevId === null || this.ebayDevId === undefined || this.ebayDevId === 'undefined') {
      this.statusText16 = 'Please enter Dev Id';
    }
  }
  typeEbayCertId() {
    this.statusText17 = "";
    if (this.ebayCertId == '' || this.ebayCertId === null || this.ebayCertId === undefined || this.ebayCertId === 'undefined') {
      this.statusText17 = 'Please enter Cert ID';
    }
  }
  typeEbayAppId() {
    this.statusText18 = "";
    if (this.appId == '' || this.appId === null || this.appId === undefined || this.appId === 'undefined') {
      this.statusText18 = 'Please enter App Id';
    }
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }
  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }
  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  syncProcess() {
    this.statusText29 = "";
    this.statusText30 = "";
    this.statusText31 = "";
    this.statusText32 = "";
    this.statusText33 = "";
    this.statusText34 = "";
    this.statusText35 = "";

    if (this.store.syncType == 'PERIODICALLY') {
      if (this.store.startDate == '' || this.store.startDate === null || this.store.startDate === undefined || this.store.startDate === 'undefined') {
        this.statusText30 = 'Please select start date';

      }
      if (this.store.duration == '' || this.store.duration === null || this.store.duration === undefined || this.store.duration === 'undefined') {
        this.statusText32 = 'Please select frequency';

      }
      if (this.store.durationType == '' || this.store.durationType === null || this.store.durationType === undefined || this.store.durationType === 'undefined') {
        this.statusText33 = 'Please select duration type';

      }
      if (this.statusText30 != "" || this.statusText32 != "" || this.statusText33 != "") {
        this.g.loaderDisplay = "";
        return false;
      }
    }
    if (this.store.syncType != 'PERIODICALLY') {
      if (this.store.sstartDate == '' || this.store.sstartDate === null || this.store.sstartDate === undefined || this.store.sstartDate === 'undefined') {
        this.statusText34 = 'Please select start date';
        return false;
      }
    }

    this.g.loaderDisplay = "display";
    let configSchedule;
    if (this.store.syncType == 'PERIODICALLY') {
      configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId,
        "requestList": [
          {
            "accountOwnerId": this.user.accountOwnerId,
            "duration": this.store.duration,
            "durationType": this.store.durationType,
            "organizationId": 1,
            "syncType": this.store.syncType,
            "storeId": this.storeId,
            "startDate": this.store.startDate,
            "endDate": this.store.endDate,
          }
        ]
      };
    }
    else {
      configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId,
        "requestList": [
          {
            "accountOwnerId": this.user.accountOwnerId,
            // "dates": "string",
            "organizationId": 1,
            "syncType": this.store.syncType,
            "storeId": this.storeId,
            "startDate": this.store.sstartDate,
            "endDate": this.store.eendDate,
            // "week": "string"
          }
        ]
      }
    };
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/configureSchedulingTime', configSchedule,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        this.sync = 'N';
        this.router.navigate(['/admin/storeIntegrations']);
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }



  getOrdersFromEbay() {
    this.startDateError = '';
    this.endDateError = '';
    this.noOfDaysError = '';
    let startDate = '';
    let endDate = '';

    if (this.selectPeriodicType == 'Last Days') {
      if (!this.noOfDays) {
        this.noOfDaysError = "Please enter no of days";
        return;
      }
      startDate = moment().subtract(this.noOfDays, 'days').format("MM/DD/YYYY");
      endDate = moment().format("MM/DD/YYYY");
    }
    else {
      if (!this.startDate) {
        this.startDateError = "Please enter start date";
      }
      if (!this.endDate) {
        this.endDateError = "Please enter end date";
      }
      if (!this.startDate || !this.endDate) {
        return;
      }
      startDate = moment(this.startDate).format("MM/DD/YYYY")
      endDate = moment(this.endDate).format("MM/DD/YYYY");
    }
    this.g.loaderDisplay = "display";

    this.api.getOrdersFromEbay(this.user.accountOwnerId, startDate, endDate).subscribe((data: any) => {
      this.g.loaderDisplay = "";

      this.ebayOrders = data;
      if (data['code'] == 200) {
        this.alertService.success('Ebay Order', 'created Successfully');

        //this.orderSucessMessage = data['message'];
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "";

        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }
  getProductsFromEbay() {
    this.startDateErrorProducts = '';
    this.endDateErrorProducts = '';
    this.noOfDaysErrorProducts = '';
    let startDateProducts = '';
    let endDateProducts = '';

    if (this.selectPeriodicTypeProducts == 'Last Days') {
      if (!this.noOfDaysProducts) {
        this.noOfDaysErrorProducts = "Please enter no of days";
        return;
      }
      startDateProducts = moment().subtract(this.noOfDaysProducts, 'days').format("MM/DD/YYYY");
      endDateProducts = moment().format("MM/DD/YYYY");
    }
    else {
      if (!this.startDateProducts) {
        this.startDateErrorProducts = "Please enter start date";
      }
      if (!this.endDateProducts) {
        this.endDateErrorProducts = "Please enter end date";
      }
      if (!this.startDateProducts || !this.endDateProducts) {
        return;
      }
      startDateProducts = moment(this.startDateProducts).format("MM/DD/YYYY")
      endDateProducts = moment(this.endDateProducts).format("MM/DD/YYYY");
    }
    this.g.loaderDisplay = "display";

    this.api.getProductsFromEbay(this.user.accountOwnerId, startDateProducts, endDateProducts).subscribe((data: any) => {
      this.g.loaderDisplay = "";

      this.ebayProducts = data;
      if (data['code'] == 200) {
        this.alertService.success('Ebay Products', 'Product Successfully');

        //this.productSucessMessage = data['message'];
      }
      else if (data['code'] == 400) {
        this.g.loaderDisplay = "";

        this.alertService.error(data['message']);
      }
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  submitAll() {
    let request: any = {};
    if (this.tabClicked === 'PRODUCTS') {
      request = {
        "manualSyncOption": this.manualImportsProducts ? "ACTIVE" : "IN_ACTIVE",
        "organizationId": 1,
        "storesManagementId": this.storeId,
        "scheduleOption": this.scheduleProducts ? "ACTIVE" : "IN_ACTIVE",
        "syncType": this.tabClicked
      };
      if (this.syncProductId !== '') {
        request.id = this.syncProductId;
      }
    } else {
      request = {
        "organizationId": 1,
        "manualSyncOption": this.manualImports ? "ACTIVE" : "IN_ACTIVE",
        "syncOption": this.importOrders ? "ACTIVE" : "IN_ACTIVE",
        "updateOption": this.updateOrders ? "ACTIVE" : "IN_ACTIVE",
        "scheduleOption": this.scheduleOrders ? "ACTIVE" : "IN_ACTIVE",
        "pushStatuses": this.concatStatus,
        "syncStatuses": this.selectedItems,
        "additionalSyncStatuses": this.fulfillmentStatus,
        "storesManagementId": this.storeId,
        "syncType": this.tabClicked
      };
      if (this.syncId !== '') {
        request.id = this.syncId;
      }
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createStoreConfigurations', request,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          if (this.tabClicked === 'PRODUCTS') {
            this.syncProductId = data['id'] || '';
          } else {
            this.syncId = data['id'] || '';
          }
          this.alertService.success('Status', 'Submitted Successfully');

        }
      },
      );
  }
  submitSyncStatus(label, status) {
    let concatStatus = '';
    if (this.sysnOrders && this.sysnOrders.length) {
      let index = this.sysnOrders.findIndex((d) => d.label === label);
      if (index > -1) {
        this.sysnOrders[index].status = status;
      } else {
        this.sysnOrders.push({ label, status });
      }
    } else {
      this.sysnOrders.push({ label, status });
    }
    this.sysnOrders.forEach((s) => {
      if (s.label && s.status) {
        concatStatus = concatStatus + (concatStatus === '' ? '' : ',') + s.label + '=' + s.status;
      }
    });
    this.selectedItems = concatStatus;
    this.submitAll();
  }
  submitSyncFulfillStatus(label, status) {
    let concatStatus = '';
    if (this.sysnFulfillOrders && this.sysnFulfillOrders.length) {
      let index = this.sysnFulfillOrders.findIndex((d) => d.label === label);
      if (index > -1) {
        this.sysnFulfillOrders[index].status = status;
      } else {
        this.sysnFulfillOrders.push({ label, status });
      }
    } else {
      this.sysnFulfillOrders.push({ label, status });
    }
    this.sysnFulfillOrders.forEach((s) => {
      if (s.label && s.status) {
        concatStatus = concatStatus + (concatStatus === '' ? '' : ',') + s.label + '=' + s.status;
      }
    });
    this.fulfillmentStatus = concatStatus;
    this.submitAll();
  }
  submitStatus(label, status) {
    let concatStatus = '';
    if (this.orders && this.orders.length) {
      let index = this.orders.findIndex((d) => d.label === label);
      console.log(index);
      if (index > -1) {
        this.orders[index].status = status;
      } else {
        this.orders.push({ label, status });
      }
    } else {
      this.orders.push({ label, status });
    }
    this.orders.forEach((s) => {
      concatStatus = concatStatus + (concatStatus === '' ? '' : ',') + s.label + '=' + s.status;
    });
    console.log(concatStatus);
    this.concatStatus = concatStatus;
    this.submitAll();
  }


  selectDateType() {
    this.startDateError = '';
    this.endDateError = '';
    this.noOfDaysError = '';
    if (this.selectPeriodicType === 'Date Range') {
      this.noOfDays = null;
    } else {
      this.startDate = '';
      this.endDate = '';
    }
  }
  selectDateTypeProducts() {
    this.startDateErrorProducts = '';
    this.endDateErrorProducts = '';
    this.noOfDaysErrorProducts = '';
    if (this.selectPeriodicTypeProducts === 'Date Range') {
      this.noOfDaysProducts = null;
    } else {
      this.startDateProducts = '';
      this.endDateProducts = '';
    }
  }


  openDetailSection(sectionName) {
    this.tabActive = sectionName;
    if (this.manualImports) {
      this.selectPeriodicType = "Date Range";
    } else {
      this.selectPeriodicType = "";
    }
    if (this.manualImportsProducts) {
      this.selectPeriodicTypeProducts = "Date Ranges";
    } else {
      this.selectPeriodicTypeProducts = "";
    }
    if (this.scheduleProducts) {
      this.store.syncTypes = "PERIODICALY";
    } else {
      this.store.syncTypes = "";
    }
    if (this.scheduleOrders) {
      this.store.syncType = "PERIODICALLY";
    } else {
      this.store.syncType = "";
    }
  }

  removeStore(index) {
    this.deleteApiPop = 'Y';
    this.index = index;
  }

  closePopup() {
    this.deleteApiPop = 'n';
  }
  deleteSchedule(id, index) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteSchedule', {
      "accountOwnerId": this.user.accountOwnerId,
      "id": id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.scheduleStores.splice(index, 1);
          this.alertService.success('', 'Schedule Deleted Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  editPopup(index) {
    this.editApiPop = 'Y';
    this.index = index;
  }

  closeEditPopup() {
    this.editApiPop = 'n';
  }
  editSchedule(id, index) {
    /*this.statusText36 ="";
    this.statusText37 ="";
    this.statusText38 ="";
    this.statusText39 ="";

    if (this.scheduleStore.syncType == 'PERIODICALLY'){
          if (this.scheduleStore.startDate == '' || this.scheduleStore.startDate === null || this.scheduleStore.startDate === undefined || this.scheduleStore.startDate === 'undefined') {
                        this.statusText36 = 'Please select start date';

                }
          if (this.scheduleStore.duration == '' || this.scheduleStore.duration === null || this.scheduleStore.duration === undefined || this.scheduleStore.duration === 'undefined') {
                        this.statusText37 = 'Please select duration';

                }
          if (this.scheduleStore.durationType == '' || this.scheduleStore.durationType === null || this.scheduleStore.durationType === undefined || this.scheduleStore.durationType === 'undefined') {
                        this.statusText38 = 'Please select duration type';

                }
    if (this.statusText36 != "" ||this.statusText37 != "" ||this.statusText38 != "") {
           this.g.loaderDisplay = "";
           return false;
        }
    }
    if (this.scheduleStore.syncType != 'PERIODICALLY'){
          if (this.scheduleStore.sstartDate == '' || this.scheduleStore.sstartDate === null || this.scheduleStore.sstartDate === undefined || this.scheduleStore.sstartDate === 'undefined') {
                        this.statusText39 = 'Please select start date';
           return false;
                }
    }

        this.g.loaderDisplay = "display";
        let configSchedule;
        if(this.scheduleStore.syncType == 'PERIODICALLY'){
        configSchedule = {
        "accountOwnerId": this.user.accountOwnerId,
             "duration": this.scheduleStore.duration,
             "durationType": this.scheduleStore.durationType,
             "organizationId": 1,
             "syncType": this.scheduleStore.syncType,
             "storeId": this.scheduleStoreManage.id,
             "startDate": this.scheduleStore.startDate,
             "endDate": this.scheduleStore.endDate,
            "accountOwnerId": this.user.accountOwnerId,
            "duration": this.scheduleStore.duration,
            "durationType": this.scheduleStore.durationType,
            "endDate": this.scheduleStore.endDate,
            "id": this.scheduleStoreManage.id,
            "syncType": this.scheduleStore.syncType,
            "organizationId": 1,
            "startDate": this.scheduleStore.startDate,
            "storeConfigId": this.scheduleStoreManage.id,
            "storeId": 0,
            "syncFrequency": "string",
            "week": "string"
             };
            }
            else{
            configSchedule = {
            "accountOwnerId": this.user.accountOwnerId,
             "organizationId": 1,
             "syncType": this.scheduleStore.syncType,
             "storeId": this.scheduleStoreManage.id,
             "startDate": this.scheduleStore.sstartDate,
             "endDate": this.scheduleStore.eendDate
        //     "dates": "string",
          //   "week": "string"
        "accountOwnerId": 0,
            "dates": "string",
            "duration": "string",
            "durationType": "string",
            "endDate": "string",
            "id": 0,
            "lastSyncDate": "2020-10-12T13:03:35.563Z",
            "organizationId": 0,
            "specificType": "string",
            "startDate": "string",
            "storeConfigId": 0,
            "storeId": 0,
            "syncFrequency": "string",
            "syncType": "string",
            "week": "string"
         }
        };*/
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateSchedule', [],
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success('', 'Schedule Updated Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  getSessionId() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.get(environment.apiUrl + 'api/getEbaySessionId?organizationId=1',
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.sessionId = data['sessionId'];
          this.alertService.success('Session ID', data['message']);
          window.location.href = "https://signin.sandbox.ebay.com/ws/eBayISAPI.dll?SignIn&runame=Shift-Shift-Shift-SBX-nmktlh&SessID=" + this.sessionId;
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
